import i18n from '@i18next/i18n';
import { openPay } from '@src/js/common/ark-extensions/dc-components/pay';
import { isVipByFetch } from '@src/js/common/ark-extensions/dc-components/vip-linktext';
import ua from '@tencent/docs-user-agent';
import MModal from '@tencent/dui-mobile/lib/components/Modal';
import { SlideTemplateSelector } from '@tencent/slide-template-selector';
import '@tencent/slide-template-selector/dist/style.css';
import { getAidForReport } from '@tencent/txdocs-aid';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { TEMPLATE_LIST } from './constants';
import './index-global.less';
import { ITemplate, ITemplateProps } from './interface';

const useVip = () => {
    const [isVip, setIsVip] = useState(false);

    useEffect(() => {
        isVipByFetch().then((isVip) => {
            window.log.info('ai user vip status:', isVip);
            setIsVip(isVip);
        });
    }, []);

    const showVIPPay = () => {
        const aid = getAidForReport({
            position: 'toolbar',
            feature: 'template-ai',
            apprec1: 'slide',
        });

        openPay(aid, undefined, { onSuccess: () => {
            setIsVip(true);
        } });
    };

    return [isVip, showVIPPay] as const;
};

export const MobileTemplateModal: React.FC<ITemplateProps> = ({
    handleVisibleChange = () => {},
    onConfirmTemplateModal = () => {},
}) => {
    const templateList = TEMPLATE_LIST;
    const [modalVisible, setModalVisible] = useState(true);

    const [template, setTemplate] = useState(templateList[0]);

    const onConfirm = (template: ITemplate, enableImageGeneration: boolean) => {
        setModalVisible(false);
        onConfirmTemplateModal(template, enableImageGeneration);
    };

    const pickTemplate = (selectedTemplate) => {
        setTemplate(selectedTemplate);
    };

    const renderFooter = () => (
        <div className="template-force-modal-footer">
            <div
                className="template-force-modal-footer-continue"
                onClick={() => onConfirm({ id: template.id, isCustom: false }, false)}
            >
                {i18n.t('继续生成')}
            </div>
        </div>
    );

    const renderTemplateList = () => (
        <div className={'template-force-content-right'}>
            {templateList.map((item, idx) => (
                <div
                    key={idx}
                    className={`template-force-content-right-block ${
                        item.id === template.id ? 'template-force-content-right-block-selected' : ''
                    }`}
                    style={{ backgroundImage: `url("${item.cover}")` }}
                    onClick={() => pickTemplate(item)}
                ></div>
            ))}
        </div>
    );

    return (
        <MModal
            className={'template-force-modal template-force-modal--mobile'}
            title={i18n.t('选择主题模板')}
            visible={modalVisible}
            onClose={() => handleVisibleChange(false)}
            footer={renderFooter()}
            zIndex={10000}
            maskStyle={{ background: '#000000A3' }}
            closable={false}
            maskClosable={false}
        >
            <div className="template-force-content">{renderTemplateList()}</div>
        </MModal>
    );
};

export const PcTemplateModal: React.FC<ITemplateProps> = ({
    handleVisibleChange = () => {},
    onConfirmTemplateModal = () => {},
}) => {
    const [modalVisible, setModalVisible] = useState(true);
    const [isVip, showVIPPay] = useVip();

    const onConfirm = (template: ITemplate, enableImageGeneration: boolean) => {
        setModalVisible(false);
        onConfirmTemplateModal(template, enableImageGeneration);
    };

    return (
        <SlideTemplateSelector
            closable={false}
            isVip={isVip}
            showVIPPay={showVIPPay}
            visible={modalVisible}
            handleVisibleChange={handleVisibleChange}
            onConfirm={onConfirm}
        />
    );
};

export const showTemplateModal = () => {
    const containerId = '#ai-modal-container';
    const container = document.querySelector(containerId)!;

    const TemplateModal = ua.isMobile ? MobileTemplateModal : PcTemplateModal;

    return new Promise<{ templateId: string, enableImageGeneration: boolean } | undefined>((resolve) => {
        ReactDOM.render(
            <TemplateModal
                handleVisibleChange={(visible) => {
                    if (!visible) {
                        resolve(undefined);
                        ReactDOM.unmountComponentAtNode(container);
                    }
                }}
                onConfirmTemplateModal={(t, enableImageGeneration) => {
                    resolve({ templateId: t.id, enableImageGeneration });
                    ReactDOM.unmountComponentAtNode(container);
                }}
            />,
            container,
        );
    });
};
